<template>
  <div class="supplier-contacts-actions">
    <div class="listing-title">{{ $t(titleAllOrFiltered) }}</div>

    <div class="search">
      <tol-type-ahead
        :display-value="supplierContactsSearchParam"
        :search-params="{
          url: '/supplier-contacts/list',
          searchKeys: ['searchParam'],
          urlParams: {
            recordsPerPage: supplierContactsRecordsPerPage,
            offset: supplierContactsRecordsOffset,
            sortBy: supplierContactsSortField,
            sortDirection: supplierContactsSortDirection
          }
        }"
        :results-in-dropdown="false"
        :allow-empty-search="true"
        @filtered="onFiltered($event)"
        @search-in-progress="onSearchInProgress($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="action-btns">
      <router-link to="/supplier-contacts/create">
        <TolAltButton icon-name="plus" :label="$t('supplierContacts.listing.actions.new')" />
      </router-link>
      <TolAltButton
        v-click-outside="() => (displayExportOptions = false)"
        icon-name="file-excel"
        :label="$t('supplierContacts.listing.actions.exportToExcel')"
        @click="displayExportOptions = !displayExportOptions"
      />
      <Dropdown
        v-if="displayExportOptions"
        :menu-items="[
          { icon: '', label: $t('supplierContacts.listing.actions.exportAll') },
          { icon: '', label: $t('supplierContacts.listing.actions.exportPage') }
        ]"
        class="dropdown-menu-right dropdown-display"
        @optionClicked="onMenuOptionSelected($event)"
      />
    </div>
  </div>
</template>
<script>
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  SupplierContactsListingActions,
  SupplierContactsListingGetters
} from '@/app/features/supplier-contacts/features/supplier-contacts-listing/supplier-contacts-listing.keys';
import Dropdown from '@/app/components/Dropdown';
import vClickOutside from 'v-click-outside';
export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    TolAltButton,
    Dropdown,
    TolTypeAhead
  },
  props: {
    titleAllOrFiltered: {
      type: String,
      default: 'supplierContacts.listing.all'
    }
  },
  data() {
    return {
      displayExportOptions: false
    };
  },
  computed: {
    supplierContactsSearchParam() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsSearchParam];
    },
    supplierContactsRecordsPerPage() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsPerPage];
    },
    supplierContactsRecordsOffset() {
      return this.$store.getters[SupplierContactsListingGetters.SupplierContactsListingOffset];
    },
    supplierContactsSortField() {
      return this.$store.getters[SupplierContactsListingGetters.SortBy];
    },
    supplierContactsSortDirection() {
      return this.$store.getters[SupplierContactsListingGetters.SortDirection];
    }
  },
  methods: {
    onMenuOptionSelected(event) {
      this.displayExportOptions = false;
      this.$store.dispatch(
        SupplierContactsListingActions.ExportSupplierContactsAsExcel,
        event.menuOption
      );
    },
    onFiltered(results) {
      this.$store.dispatch(SupplierContactsListingActions.UpdateSupplierContactsList, results);
    },
    onSearchInProgress(searchFlag) {
      this.$emit('load-spinner', searchFlag);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.supplier-contacts-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;
  align-items: center;

  .listing-title {
    color: $text-color-dark;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.24px;
    line-height: 28px;
    flex-basis: 25%;
  }
  .search-container {
    margin-right: 3px;
  }
  .action-btns {
    display: flex;
    position: relative;
    margin-left: auto;

    justify-content: flex-end;
    flex-basis: 25%;
    .supplier-action {
      width: 50px;
      height: 50px;
      padding: 0;
      margin: 0px 0px 0px 40px;

      font-size: 1.5em;
      margin-right: 20px;
      color: $white;
      border-radius: 100%;
      background-color: $light-grey-2;
      &:hover {
        background-color: $secondary-green;
      }
    }

    a,
    a.wrapper {
      text-decoration: none;
      color: inherit;
    }
    .wrapper {
      margin-right: 3px;
    }
  }
  .dropdown-display {
    border-right: 1px solid $row-border;
    border-left: 1px solid $row-border;
    border-bottom: 1px solid $row-border;
    font-weight: bold;
  }
  .search {
    display: flex;
    flex-basis: 50%;
    .search-container {
      flex: 1;
    }
  }
}
</style>
